import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiHome, FiClock, FiArrowLeft, FiMail } from "react-icons/fi";
import { setTitle } from "../../../utils/commonfunction";

function ComingSoon({
  title = "Something Celestial is on the Way",
  badge = "COMING SOON",
  description = "We are currently crafting this feature with cosmic alignment to bring you an extraordinary astrology experience. Stay tuned as we prepare for the next phase of our launch.",
  returnPath = "/",
}) {
  useEffect(() => {
    setTitle(`${title} | Astro Adi`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [title]);

  return (
    <div className="coming-soon-wrapper bg-white">
      {/* ===== Hero Banner Section ===== */}
      <section className="relative bg-[url('../../images/banner.png')] bg-cover bg-center !pt-[78px] md:!pt-[88px] !pb-[16px] md:!pb-[22px] overflow-hidden text-center">
        {/* Dark overlay for rich contrast */}
        <div className="absolute inset-0 bg-black/70 z-[1]"></div>

        <div className="container relative z-[2] mx-auto px-4">
          <div className="max-w-[700px] mx-auto flex flex-col items-center gap-1.5">
            {/* Glowing Golden Badge */}
            <div className="inline-flex items-center gap-1.5 px-3 py-0.5 rounded-full bg-yellow-500/15 border border-yellow-400/50 text-yellow-400 text-[11px] md:text-xs font-semibold tracking-wider uppercase shadow-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-yellow-400 animate-pulse"></span>
              {badge}
            </div>

            {/* Page Title */}
            <h1 className="web-h1 text-white text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight m-0 drop-shadow-md">
              {title}
            </h1>

            {/* Breadcrumb Navigation */}
            <nav className="inline-flex items-center gap-2 bg-black/40 backdrop-blur-md px-3.5 py-1 rounded-full border border-white/10 text-xs text-gray-300 mt-0.5">
              <Link
                to="/"
                className="text-gray-300 hover:text-yellow-400 no-underline transition-colors flex items-center gap-1"
              >
                <FiHome className="text-xs" />
                <span>Home</span>
              </Link>
              <span className="text-gray-500">/</span>
              <span className="text-yellow-400 font-medium">Coming Soon</span>
            </nav>
          </div>
        </div>
      </section>

      {/* ===== Main Section ===== */}
      <section className="pt-6 md:pt-8 pb-12 md:pb-16 bg-gray-50/70 relative overflow-hidden">
        {/* Decorative background shapes */}
        <div className="absolute top-[10%] right-0 hidden 2xl:block opacity-40 pointer-events-none">
          <img src="/images/shape1.png" alt="" />
        </div>
        <div className="absolute bottom-[10%] left-0 hidden 2xl:block opacity-40 pointer-events-none">
          <img src="/images/shape2.png" alt="" />
        </div>

        <div className="container max-w-3xl mx-auto px-4 sm:px-6 relative z-[2]">
          {/* Main Card */}
          <div className="bg-white rounded-3xl p-8 sm:p-10 md:p-12 shadow-xl shadow-gray-200/60 border border-gray-100 text-center">
            {/* Hourglass / Cosmic Icon */}
            <div className="w-20 h-20 mx-auto mb-6 rounded-3xl bg-gradient-to-tr from-yellow-400/20 via-amber-300/30 to-yellow-500/20 border border-yellow-400/40 flex items-center justify-center text-yellow-600 text-3xl shadow-md shadow-yellow-500/10">
              <FiClock className="animate-spin-slow" />
            </div>

            <h2 className="web-h2 text-gray-900 text-2xl sm:text-3xl font-bold mb-3 tracking-tight">
              Under Active Development
            </h2>

            <p className="text-gray-600 text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-8">
              {description}
            </p>

            {/* Action Buttons */}
            <div className="pt-6 border-t border-gray-100 flex flex-wrap items-center justify-center gap-3">
              <Link
                to={returnPath}
                className="custom-btn custom-btn-primary !px-7 !py-3 flex items-center gap-2 text-sm md:text-base font-semibold shadow-md shadow-yellow-500/20 !no-underline"
              >
                <FiArrowLeft />
                <span>Return to Home Page</span>
              </Link>
              <Link
                to="/contact"
                className="px-6 py-3 rounded-full border border-gray-300 hover:border-yellow-500 text-gray-700 hover:text-yellow-600 transition-colors text-sm md:text-base font-medium !no-underline flex items-center gap-2 bg-white"
              >
                <FiMail className="text-sm" />
                <span>Contact Us</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Slow spinning animation for clock icon */}
      <style>{`
        @keyframes spinSlow {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spinSlow 12s linear infinite;
        }
      `}</style>
    </div>
  );
}

export default ComingSoon;

